import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=3ca63302&scoped=true&"
var script = {}
import style0 from "./Hero.vue?vue&type=style&index=0&id=3ca63302&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca63302",
  null
  
)

component.options.__file = "Hero.vue"
export default component.exports